import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=95820226&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=95820226&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95820226",
  null
  
)

export default component.exports